export default "/images/simpl-logo.png";